import { FDCheckboxInput } from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import PropTypes from 'prop-types';
import { useDataAttrs } from 'Helpers/Testing';

function determineCheckedStatus(val) {
  if (typeof val === 'boolean') {
    return val === true;
  }

  if (typeof val === 'string') {
    return val.toLowerCase() === 'true';
  }

  return val;
}

const CheckboxInput = (props) => {
  const {
    alignSelf,
    flex,
    flexGrow,
    flexShrink,
    fullWidth,
    disabled,
    error,
    helperTextValue,
    label,
    onBlur,
    onChange,
    onFocus,
    readonly,
    size,
    value,
    ...rest
  } = props;

  const checked = determineCheckedStatus(value);

  return (
    <FDCheckboxInput
      {...useDataAttrs(rest)}
      alignSelf={alignSelf}
      disabled={disabled || readonly}
      error={error}
      flex={flex}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      fullWidth={fullWidth}
      helperText={helperTextValue}
      label={label}
      onBlur={onBlur}
      onChange={(val) => (val === undefined ? onChange('') : onChange(val))}
      onFocus={onFocus}
      size={size}
      checked={checked}
    />
  );
};

CheckboxInput.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  disabled: inputDefaultProps.disabled,
  error: inputDefaultProps.error,
  flex: inputDefaultProps.flex,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  fullWidth: inputDefaultProps.fullWidth,
  helperTextValue: inputDefaultProps.helperTextValue,
  label: inputDefaultProps.label,
  onBlur: inputDefaultProps.onBlur,
  onFocus: inputDefaultProps.onFocus,
  readonly: inputDefaultProps.readonly,
  value: undefined,
};

CheckboxInput.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  disabled: inputPropTypes.disabled,
  flex: inputPropTypes.flex,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  label: PropTypes.node,
  size: inputPropTypes.size.isRequired,
  helperTextValue: inputPropTypes.helperTextValue,
  error: inputPropTypes.error,
  value: PropTypes.bool,
  onBlur: inputPropTypes.onBlur,
  onChange: inputPropTypes.onChange.isRequired,
  onFocus: inputPropTypes.onFocus,
  fullWidth: inputPropTypes.fullWidth,
  readonly: inputPropTypes.readonly,
};

const CheckboxInputSmall = (props) => {
  return <CheckboxInput {...props} size="sm" />;
};

const CheckboxInputLarge = (props) => {
  return <CheckboxInput {...props} size="lg" />;
};

export { CheckboxInputSmall, CheckboxInputLarge };
